import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { connect } from "react-redux"
import { logoutUser } from "../../store/actions"
import { cacheClear } from "../utils/cache"

const Logout = ({ logoutUser }) => {
  const navigate = useNavigate()

  useEffect(() => {
    // Clear auth data
    localStorage.removeItem("authUser")
    localStorage.removeItem("veeperAuthToken")

    // Clear all cached API data
    cacheClear()

    // Dispatch logout action
    logoutUser()

    // Navigate to login page
    navigate("/login", { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate])

  return null
}

export default connect(null, { logoutUser })(Logout)
